import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useLocalization } from '@im/react-localization';
import Typography from '@mui/material/Typography';
import { WarehouseETAOutOfStock } from '../WarehouseETAOutOfStock';
import { Warehouse } from '../../internal/common.types';

type Prop = {
  centralStock: number;
  centralStockJType: number;
  displayCentralFlag?: boolean;
  displayLocalFlag?: boolean;
  displayOutOfStockFlag: boolean;
  fromPage: string;
  localStock: number;
  preOrderEtaStockDetails: any;
  reserveFlag: boolean;
  reservedStock: number;
  stockStatus: string;
  tooltipsShow: boolean;
  warehouses?: Warehouse[];
};

export default function WarehouseETAStockOverMouse(props: Prop) {
  const { translate } = useLocalization();

  const {
    centralStock,
    centralStockJType,
    displayCentralFlag,
    displayLocalFlag,
    displayOutOfStockFlag,
    localStock,
    preOrderEtaStockDetails,
    reserveFlag,
    reservedStock,
    stockStatus,
    tooltipsShow,
    warehouses,
  } = props;

  const [ttShow] = useState(tooltipsShow);

  const onOrder =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'ONORDER' ? acc + cur.quantity : acc,
      0
    );

  return (
    <>
      {displayCentralFlag ||
      displayLocalFlag ||
      reserveFlag ||
      displayOutOfStockFlag ||
      stockStatus !== null ||
      onOrder > 0 ? (
        <Stack
          direction="row"
          divider={
            Boolean(displayLocalFlag) &&
            Boolean(displayCentralFlag) && (
              <Divider
                flexItem
                orientation="vertical"
                sx={{
                  borderLeftWidth: '0px',
                  borderRightWidth: '1px',
                  color: 'red',
                  margin: '0px',
                }}
              />
            )
          }
        >
          <Typography
            component="span"
            sx={{
              '&::before': {
                backgroundColor: '#E5F4FF',
                color: '#333333',
                content: '""',
                display: 'block',
                height: 12,
                left: '40%',
                position: 'absolute',
                top: -8,
                transform: 'translate(-50%, calc(-100% - 5px))',
                width: 12,
                zIndex: '999',
              },
              alignItems: 'flex-start',
              background: '#E5F4FF',
              borderRadius: '6px',
              lineHeight: '19px',
              marginTop: '8px',
              padding: '12px',
              position: 'relative',
            }}
          >
            <Typography
              sx={{
                backgroundColor: '#E5F4FF',
                fontSize: '0.875rem',
                listStyle: 'none',
              }}
            >
              {displayLocalFlag ? (
                <Box sx={{ display: 'flex' }}>
                  {displayLocalFlag ? (
                    <div
                      style={{
                        marginRight:
                          (displayLocalFlag && displayCentralFlag) ||
                          (reserveFlag && displayCentralFlag)
                            ? '0.50rem'
                            : '',
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '600' }}
                      >
                        {localStock}
                      </Typography>{' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '400' }}
                      >
                        {translate('Warehouse.ETALocalShipmentText')}{' '}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '600' }}
                      >
                        {reserveFlag
                          ? translate('Warehouse.ETAReservedQuantity', {
                              reservedStock: reservedStock.toString(),
                            })
                          : ''}
                      </Typography>
                    </div>
                  ) : (
                    ''
                  )}
                </Box>
              ) : (
                ''
              )}
              {reserveFlag && displayCentralFlag ? (
                <Box sx={{ display: 'flex' }}>
                  {reserveFlag &&
                  displayCentralFlag &&
                  !displayLocalFlag &&
                  !displayOutOfStockFlag ? (
                    <>
                      <div
                        style={{
                          marginRight:
                            reserveFlag && displayCentralFlag ? '0.50em' : '',
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{ fontSize: '12px', fontWeight: '600' }}
                        >
                          {reservedStock}
                        </Typography>{' '}
                        <Typography
                          component="span"
                          sx={{ fontSize: '12px', fontWeight: '400' }}
                        >
                          {translate('Cart.Reserved')}{' '}
                          {translate('Warehouse.ETALocalShipmentText')}
                        </Typography>
                      </div>
                      {reserveFlag && displayCentralFlag && (
                        <hr
                          className="MuiDivider-root MuiDivider-fullWidth MuiDivider-vertical MuiDivider-flexItem css-h7zdi2-MuiDivider-root"
                          data-testid="required"
                        />
                      )}
                    </>
                  ) : (
                    ''
                  )}
                </Box>
              ) : (
                ''
              )}
              {displayCentralFlag ? (
                <Box sx={{ display: 'flex' }}>
                  {displayCentralFlag && centralStock > 0 ? (
                    <div
                      style={{
                        marginLeft:
                          (displayLocalFlag && displayCentralFlag) ||
                          (reserveFlag && displayCentralFlag)
                            ? '0.50rem'
                            : '',
                      }}
                    >
                      {' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '600' }}
                      >
                        {centralStock}
                      </Typography>{' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '400' }}
                      >
                        {translate('Warehouse.ETACentrlShipmentText')}
                      </Typography>
                    </div>
                  ) : (
                    ''
                  )}
                </Box>
              ) : (
                ''
              )}

              {displayCentralFlag && centralStockJType > 0 ? (
                <Box sx={{ display: 'flex' }}>
                  {displayCentralFlag && centralStockJType > 0 ? (
                    <div
                      style={{
                        marginLeft:
                          (displayLocalFlag && displayCentralFlag) ||
                          (reserveFlag && displayCentralFlag)
                            ? '0.50rem'
                            : '',
                      }}
                    >
                      {' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '600' }}
                      >
                        {centralStockJType}
                      </Typography>{' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '12px', fontWeight: '400' }}
                      >
                        {translate('Warehouse.ETACentralJTypeShipmentText')}
                      </Typography>
                    </div>
                  ) : (
                    ''
                  )}
                </Box>
              ) : (
                ''
              )}

              {reserveFlag && !displayCentralFlag && !displayLocalFlag ? (
                <Box>
                  {reserveFlag && !displayCentralFlag && !displayLocalFlag ? (
                    <div>
                      {reserveFlag
                        ? `${reservedStock} ${translate(
                            'Cart.Reserved'
                          )}${' '}${translate(
                            'Warehouse.ETALocalShipmentText'
                          )}${' '}`
                        : ''}
                    </div>
                  ) : (
                    ''
                  )}
                </Box>
              ) : (
                ''
              )}
              {!reserveFlag &&
                !displayCentralFlag &&
                !displayLocalFlag &&
                stockStatus?.toLowerCase() === 'outofstock' &&
                displayOutOfStockFlag && (
                  <>
                    <WarehouseETAOutOfStock
                      centralStock={centralStock}
                      localStock={localStock}
                      preOrderEtaStockDetails={preOrderEtaStockDetails}
                      reserveFlag={props.reserveFlag}
                      tooltipsShow={ttShow}
                      warehouses={warehouses}
                    ></WarehouseETAOutOfStock>
                  </>
                )}
            </Typography>
          </Typography>
        </Stack>
      ) : null}
    </>
  );
}
